module.exports = __webpack_public_path__ + "img/9788971966105.38b16a01.jpg";